var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSection',{attrs:{"id":"invoices","type":"page","title":_vm.$t(_vm.$getConst.pages.invoice.add_invoice)}},[_c('InvoiceForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }